(() => {
  'use strict';

  const config = document.getElementById('beadifique-persistent-cart-strings');
  if (!config) return;

  let strings;
  try {
    strings = JSON.parse(config.textContent);
  } catch (_) {
    return;
  }

  const setText = (element, value) => {
    if (element && typeof value === 'string' && element.textContent !== value) {
      element.textContent = value;
    }
  };

  const enhance = (modal) => {
    if (modal.dataset.beadifiqueCartReady) return;
    const content = modal.querySelector('.modal-content');
    const body = modal.querySelector('.modal-body');
    const combine = modal.querySelector('#combineBothCartsButton');
    const keep = modal.querySelector('#keepCurrentCartButton');
    const restore = modal.querySelector('#loadFoundCartButton');
    if (!content || !body || !combine || !keep || !restore) return;

    modal.dataset.beadifiqueCartReady = 'true';
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'cffPCConflictModalTitle');
    modal.setAttribute('aria-describedby', 'cffPCConflictModalMessage');

    const actions = document.createElement('div');
    actions.className = 'bp-pc-actions';
    actions.append(combine, keep, restore);
    content.append(actions);

    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(refresh);
    });

    const watch = () => observer.observe(modal, {
      childList: true,
      subtree: true,
      characterData: true
    });

    const section = (titleId, bodyId, label) => {
      const title = modal.querySelector(titleId);
      const tableBody = modal.querySelector(bodyId);
      if (!title || !tableBody) return;

      const rows = Array.from(tableBody.rows);
      const count = rows.length;
      const countLabel = (count === 1 ? strings.one_item : strings.many_items)
        .replace('__count__', String(count));

      let name = title.querySelector('.bp-pc-section-name');
      let counter = title.querySelector('.bp-pc-count');
      if (!name || !counter) {
        name = document.createElement('span');
        name.className = 'bp-pc-section-name';
        counter = document.createElement('span');
        counter.className = 'bp-pc-count';
        title.replaceChildren(name, counter);
      }
      setText(name, label);
      setText(counter, countLabel);

      rows.forEach((row) => {
        const cells = row.cells;
        if (cells.length !== 3) return;
        const image = cells[0].querySelector('img');
        if (image) {
          image.alt = '';
          image.width = 56;
          image.height = 56;
        }
        const quantity = cells[2];
        const match = quantity.textContent.trim().match(/^(\d+)\s*x$/i);
        if (match) setText(quantity, strings.quantity.replace('__count__', match[1]));
      });

      let empty = tableBody.parentElement.nextElementSibling;
      if (!empty || !empty.classList.contains('bp-pc-empty')) {
        empty = document.createElement('p');
        empty.className = 'bp-pc-empty';
        tableBody.parentElement.after(empty);
      }
      setText(empty, strings.empty);
      empty.hidden = count !== 0;
    };

    const refresh = () => {
      scheduled = false;
      observer.disconnect();
      setText(modal.querySelector('#cffPCConflictModalTitle'), strings.title);
      setText(modal.querySelector('#cffPCConflictModalMessage'), strings.message);
      setText(combine, strings.combine);
      setText(keep, strings.keep);
      setText(restore, strings.restore);
      combine.setAttribute('aria-label', strings.combine);
      keep.setAttribute('aria-label', strings.keep_description);
      restore.setAttribute('aria-label', strings.restore_description);
      const close = modal.querySelector('.close');
      if (close) close.setAttribute('aria-label', strings.close);
      section('#cffPCFoundCartTitle', '#cffPCFoundCartCartTableMainBody', strings.saved);
      section('#cffPCCurrentCartTitle', '#cffPCCurrentCartTableMainBody', strings.current);
      watch();
    };

    refresh();
  };

  const find = () => {
    const modal = document.getElementById('cartItemsDetectedModal');
    if (!modal) return false;
    enhance(modal);
    return Boolean(modal.dataset.beadifiqueCartReady);
  };

  if (find()) return;
  const discovery = new MutationObserver((records) => {
    if (records.some((record) => record.addedNodes.length) && find()) {
      discovery.disconnect();
    }
  });
  discovery.observe(document.body, { childList: true, subtree: true });
})();
